import { render } from "./SimpleButton.vue?vue&type=template&id=11edf77a&scoped=true"
import script from "./SimpleButton.vue?vue&type=script&lang=js"
export * from "./SimpleButton.vue?vue&type=script&lang=js"

import "./SimpleButton.vue?vue&type=style&index=0&id=11edf77a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11edf77a"]])

export default __exports__